export default __webpack_public_path__ + "static/white-2i-logo-10f8502a967a3c93cb034c7155d5d1d9.png";